import { render } from "./Page.vue?vue&type=template&id=f6acd6fe&ts=true"
import script from "./Page.vue?vue&type=script&lang=tsx"
export * from "./Page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__